<template>
<div>
    <Modal
        id = "modeal"
        ref="dialog"
        v-model="isShow"
        class-name="ivu-noPadding-wrap"
        transfer
        :closable="closable"
        :footer-hide="footerHide"
        :mask-closable="false"
        :draggable=isMove
        @on-cancel="cancel">
        <p id="title" v-show="isTitle" :slot="customTitle" @mouseup="onMouseUps">
            <span>{{titleName}}</span>
        </p>
        <div style="width:0px;height:0px;">
            <div class="cs" style="position: absolute;">
            <canvas
            :style="styleZoom"
            ref="canvasNode"
            :id="registerName"
            width="0"
            height="0"
            @mousedown="onMouseDown"
            @mouseup="onMouseUp"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @mousemove="onMouseMove"></canvas>
            <component :is="item.component" v-for="item in primitivesList"
                        :primitives="item.primitives"
                        :fvSystemApi="item.fvSystemApi"
                        :parentObject="item.parentObject"
                        :key="item.registerName"></component>
            <Spin size="large" fix v-if="spinShow"></Spin>
            </div>
        </div>
    </Modal>

</div>


</template>

<style>
    /*用于设置双击界面选中图片的bug*/
    body {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        user-select: none;
    }
   #modeal .ivu-modal-wrap {
       overflow:hidden;
   }

    /* 先注释掉， 影响app旋转后组件层级问题 */
    .ivu-noPadding-wrap .ivu-modal-body {
        /* overflow:hidden; */
        padding: 0px;
    }
    .ivu-noPadding-wrap .ivu-modal-content {
        border-radius:0;
        box-shadow : 0 0 0 0;
    }
    .ivu-modal-mask{
        background-color: rgba(55,55,55,0);
    }
    #modeal .ivu-modal-header{
        padding:0 !important;
    }
    #title{
        height:51px;
        line-height: 51px;
        padding-left: 10px;
    }
</style>
<script>
import Vue from 'vue';
import echarts from 'echarts';
import axios from 'axios';
Vue.prototype.$echarts = echarts
import subUnit from "../../js/canvas/subUnit";
import fvSystemApi from "../../js/fvSystemApi";
export default {
    name: 'windowComponent',
    props : ["windowInfo"],
    created : function(){
        Object.assign(this,this.windowInfo);
        this.titleName = this.registerName;
        //系统风格会影响draw窗口的边框宽度，仅是显示问题。但是给用户的可视使用大小会比设置要小。
        //win7风格大约为20px。不同系统风格转义时会转义不同值。为转义默认为win7风格
        this.defaultTailoring = this.defaultTailoring ? parseInt(this.defaultTailoring) : 20;
        this.zoomMagnification();
        this.canvasWidth = (parseFloat(this.width) * this.scaleX) * devicePixelRatio;
        this.canvasHeight = (parseFloat(this.height) * this.scaleY) * devicePixelRatio;
        this.windowStyle = {
            top:this.y,
            left:this.x,
            width:this.$store.state.system.$.screenWidth,
            height:this.$store.state.system.$.screenHeight,
            textAlign: "left",
            margin : "0 0px",
            padding : "0px"
        }
        if (window.addEventListener)
            window.addEventListener('DOMMouseScroll', document.onmousewheel, false);
        this.modelsPath = ['system','manager',this.registerName];
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        //此处保存了本模块的vuex对象，创建的子对象会加入到此，使前端脚本可以调用对象
        this.subObjects = this.$store.state.system.manager[this.registerName];
        //判断是否有标题 有标题加上标题的高度
        if(this.title){
            this.heightTitle = 51;
            this.isTitle = true;
            this.customTitle = "header";
            this.borderWid = 20;
            //判断是否可以拖动
            //先判断是否是标题窗口才有拖动条，才能设置是否拖动窗口
            if(this.dragger){
                this.isMove = false;
            }else{
                this.isMove = true;
            }
        }
        //系统菜单
        if(this.menuMessage){
            this.closable = this.menuMessage;
        }
        //用于弹出式窗口移动窗口前的初始值
        this.doFixEventTop = 0;
        this.doFixEventleft = 0;
        //用于存储移动窗口移动距离
        this.doFixEventOnMouseUp={
            left:0,
            top:0
        }
        //此绑定写到App.vue和managercomponent.vue中无法绑定成功，故写与此，会多次绑定暂未发现bug
        // window.onresize = this.$store.state.system.$.onResize;
        window.addEventListener('resize', () => {
            // 判断条件draw端还未添加
            if(0) {
                this.windowHeight = window.innerHeight;
                this.windowWidth = window.innerWidth;

            } else {
                this.zoomMagnification();
                this.$store.state.system.$.onResize();
            }
        });
        this.firstWindowHeight = window.innerHeight;
        this.firstWindowWidth = window.innerWidth;
        window.onkeydown = this.$store.state.system.$.onKeyDown.bind(this);
        window.onkeyup = this.$store.state.system.$.onKeyUp.bind(this);
    },
    mounted : function(){
        this.init();
        this.iskko = false;
        this.isokk = false;
        if(this.fcchildren){
            //先确定canvas大小。this.windowSize属性需要在对象常见时使用
            this.fcchildren.forEach(element => {
                if(element==undefined||element==null){
                    return;
                }
                //draw边框导致所有图元需要按比例随访位置
                element.frameScaleX = this.defaultTailoring / this.width;
                element.frameScaleY = this.defaultTailoring / this.height;
                if(this.canvasWidth < (element.x+element.width)*this.scaleX){
                    this.canvasWidth = (element.x+element.width)*this.scaleX;
                    this.iskko = true;
                }
                if(this.canvasHeight < (element.y+element.height)*this.scaleY){
                    this.canvasHeight = (element.y+element.height)*this.scaleY;
                    this.isokk = true;
                }
            });
            var func = [];
            this.fcchildren.forEach((element,i)=> {
                if(element==undefined||element==null){
                    return;
                }
                // 特殊情况处理（恢复老工程多折线lineType设置为立体管道，多折线不存在立体管道类型，所以转为管道类型绘制图元）
                if((element.fctype === 'fvPolygonObj' || element.fctype === 'fvPolylineObj') && element.lineType === -1){
                    element.fctype = 'fvPipeObj';
                    // 转义json线宽为0，暂时按照现场bug设置为3
                    //element.borderWidth = 3;
                }

                func.push(new Promise((resolve,rejected)=>{
                    try{
                        if(Vue.component(element.fctype)){
                            //if(element.fctype != "fvGroupObj"){
                                element.x += element.x * element.frameScaleX;
                                element.y += element.y * element.frameScaleY;
                                element.height += element.height * element.frameScaleY;
                                element.width += element.width * element.frameScaleX;
                            //}
                            this.primitivesList.push({
                                component : element.fctype,
                                primitives : element,
                                registerName : element.registerName,
                                parentObject : this,
                                fvSystemApi : new fvSystemApi(this.$store.state.system),
                            });
                            resolve();
                        }else{
                            new subUnit[element.fctype](element,this,this.$store.state.system,(obj)=>{
                                this.subObjects[obj.name] = {
                                    "$" : obj
                                };
                                this.zIndexObjList.push({
                                    name:obj.name,
                                    zIndex : obj.zIndex
                                })
                                resolve();
                            });
                        }

                    }catch(e){
                        console.log("此类型不存在：%c" + element.fctype,'color:#f00;');
                        console.log(e);
                        resolve();
                    }
                }));
            });
            Promise.all(func).then(() => {
                this.fcchildren.forEach((element,i)=> {
                    if(element==undefined||element==null){
                        return;
                    }

                    if(Vue.component(element.fctype)){
                        this.primitivesList.forEach((e)=>{
                            if(element.registerName == e.registerName){
                                if(this.$store.state.system.manager[e.parentObject.registerName]){
                                    this.subObjects[e.registerName] = this.$store.state.system.manager[e.parentObject.registerName][e.registerName];
                                }
                                this.zIndexObjList.push({
                                    name : element.registerName,
                                    zIndex : element.zIndex
                                })
                            }
                        })
                    }
                })
                this.zIndexObjList.sort(function(obj1,obj2){
                    return obj1.zIndex - obj2.zIndex;
                });
                this.onSuccess();
            });

        }
    },
    distroyed : function(){
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    },
    data : function(){
        return {
            windowHeight: null,
            windowWidth: null, // 窗口变实时尺寸
            firstWindowHeight: null,
            firstWindowWidth: null, // 窗口首次渲染的尺寸
            titleName : "",
            isFocusWindow : false,
            winType : "pc",
            styleZoom:{
                display: "block"//顶替iview inline-block 否则下边有缝隙
            },//canvas 缩放样式
            modelsPath : [],
            spinShow : false,
            //关闭按钮
            closable:false,
            //自定义标题
            customTitle :"",
            //判断是否拖动
            isMove:true,
            //标记点击的是否是关闭按钮
            iscancel:true,
            isNowClose : true,
            footerHide : true,
            isTitle : false,
            primitivesList : [],
            subObjects : {},
            lastTime : new Date().getTime(),
            isClose : false,
            isShow : false,
            ctx : null,
            zoom : 0,
            domScale : {
                zoom : 0,
                x:this.y,
                y:this.x,
                sx: 1,
                sy: 1,
                ox: 0,
                oy: 0,
                scrollHeight : 0,
                scrollWidth : 0,
                titleHeight : 0
            },
            isOpenSuccess : false,
            zIndexObjList : [],
            //初始化对话框样式
            windowStyle : {
                top:0,
                left:0,
                textAlign: "left",
                margin : "0 0",
                padding : "0px"
            },
            selected : null,
            heightTitle : 0,
            borderWid:0,
            turn:"selfAdaption",//"transverse"：横向 "portrait" ：纵向 "selfAdaption"：自适应
            openOtimer : true,//控制周期执行
            requestAnimationFrameInterval:new Date().getTime(),
            isOpneShow : true,


        }
    },
    watch: {
        windowHeight() {
            if(this.windowHeight !== this.firstWindowHeight) {
                // 差值
                let diff = (this.firstWindowHeight - this.windowHeight) / this.firstWindowHeight;
                // 新值
                let newY = (parseFloat(this.windowHeight) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
                let res = this.windowWidth - this.windowWidth * diff;
                let newX = parseFloat(res) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleX = newX;
                this.scaleY = newY;
                this.$store.state.system.$.onResize();
            }
            if(this.windowHeight == this.firstWindowHeight) {
                this.zoomMagnification();
                this.$store.state.system.$.onResize();
            }
        },
        windowWidth() {
            if(this.windowWidth !== this.firstWindowWidth) {
                // 差值
                let diff = (this.firstWindowWidth - this.windowWidth) / this.firstWindowWidth;
                // 新值
                let newX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                let res = this.windowHeight - this.windowHeight * diff;
                let newY = (parseFloat(res) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
                this.scaleX = newX;
                this.scaleY = newY;
                this.$store.state.system.$.onResize();
            }
            if(this.windowWidth == window.screen.width) {
                this.zoomMagnification();
                this.$store.state.system.$.onResize();
            }
        },
    },
    methods : {
        setTitle(name){
            this.titleName = name;
        },
        async init(){
            // this.isShow = true;
            this.$store.state.system.$.getData();
            this.tcanvasNode = this.$refs.canvasNode;
            this.ctx = this.tcanvasNode.getContext("2d");
            this.tcanvasNode.width = this.canvasWidth;
            this.tcanvasNode.height = this.canvasHeight;
            this.onDraw();
        },
        //弹出式窗口点击叉子调用
        cancel(){
            this.$parent.closeWindow(this.registerName);
            this.iscancel = false;
           // this.onClose();
        },
        /*
            参数：无
            作用：计算缩放比例
        */
        zoomMagnification(){
            
            if(isApp()){
                var appTailoring = this.$store.state.system.$.appWinTitleHeight + this.$store.state.system.$.appWinSysHeight;
                this.scaleX = parseFloat(window.innerHeight - appTailoring) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleY = (parseFloat(window.innerWidth)-this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight)+this.heightTitle) ;
            }else{
                this.scaleX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
            }
            if(this.turn == "portrait" || this.turn == "transverse"){
                this.scaleX = 1;
                this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
            }else if(this.turn == "portraits"){
                this.scaleX = 1;
                this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle-70) / (parseFloat(this.$store.state.system.$.screenHeight));
            }
            if(this.$store.state.system.$.embedView == 1){
                if(innerHeight>innerWidth){
                    var rotate = 0;
                }else{
                    var rotate = 90;
                }
                if (rotate === 90) {
                    this.scaleX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                    this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
                } else {
                    this.scaleX = 1;
                    this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));

                }
            }
        },
        /*
            参数：无
            作用：获取缩放比例
        */
        getMagnification(){
            return {
                x : this.scaleX,
                y : this.scaleY
            }
        },
        /*
            参数：无
            作用：窗口加载完成
        */
        async onSuccess(){
            //因请求窗口json 使用延迟处理，所以进入窗口动作也要同步等待
            setTimeout(()=>{
                this.fvScript.executionScript(this.entrancescript,undefined,this.registerName);
            },20)
            this.isOpenSuccess = true;
            if(this.turn == "portrait"){
                this.x +=this.$store.state.system.$.zoomList.y;
                this.y +=this.$store.state.system.$.zoomList.x;
            }else if(this.turn == "transverse"){
                this.x +=this.$store.state.system.$.zoomList.x;
                this.y +=-this.$store.state.system.$.zoomList.y
            }else if(this.turn == "selfAdaption"){
                this.x += this.$store.state.system.$.zoomList.x ;
                this.y += this.$store.state.system.$.zoomList.y ;
            }else if(this.turn == "portraits"){
                this.x +=this.$store.state.system.$.zoomList.y;
                this.y +=this.$store.state.system.$.zoomList.x;
            }
            this.repaint();
            //调取indexdb 来设置历史回放显隐
            if(this.$store.state.system.$.indexDB[0].isOpenPlayback){
                this.$store.state.system.historyPlaybackControl.$.show(true);
            }
        },
        /*
            参数：time 当前时间
            作用：周期执行函数
        */
        onTimer(time){
            if(!this.openOtimer) return;
            var currTime = new Date().getTime();
            if(currTime - this.lastTime > 200){
                this.fvScript.executionScript(this.timerscript);
                this.lastTime = currTime;
                for(var i = 0; i<this.zIndexObjList.length;i++){
                    var obj = this.zIndexObjList[i];
                    if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == "block"){
                        if(this.subObjects[obj.name].$.onTimer){
                            this.subObjects[obj.name].$.onTimer(time);
                        }
                    }
                }
                if(this.$store.state.system.$.animationType){
                    this.onDraw();
                    //用于判断绘制图元后再去显示窗口，只需要进入一次，以免后期调用show来隐藏窗口
                    if(this.isOpneShow){
                        this.isShow = true;
                        this.isOpneShow = false;
                        //单独设置msbox 层级，不能时候 this否则iview层级会根据打开窗口的顺组来设置曾加层级
                        if(document.getElementsByClassName("msboxStyle")[0]){
                            document.getElementsByClassName("msboxStyle")[0].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.style.zIndex = this.$Modal.props.zIndex.default+30;
                        }
                    }

                }
            }

        },
        /*
            参数：无
            作用：实时数据更新时被调用
        */
        onUpdata(){
            for (var p in this.subObjects) {
                if(p == "$"){
                    continue;
                }
                if(this.subObjects[p].$.onUpdata){
                    this.subObjects[p].$.onUpdata();
                }
            };
        },
        /*
            参数：无
            作用：绘制界面
        */
        onDraw(){
            if(this.$refs.canvasNode && this.$refs.canvasNode.scrollTop){
                this.domScale.scrollHeight=this.$refs.canvasNode.scrollTop;
                this.domScale.scrollWidth=this.$refs.canvasNode.scrollLeft;
            }
            //this.ctx.clearRect(0,0,this.canvasWidth*devicePixelRatio,this.canvasHeight*devicePixelRatio);
            // console.log((this.canvasHeight*this.scaleY+300)*devicePixelRatio)
            this.ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
            if(this.spinShow){
                this.spinShow = false;
            }
            for(var i = 0; i<this.zIndexObjList.length;i++){
                var obj = this.zIndexObjList[i];
                if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == "block"){
                    if(this.subObjects[obj.name].$.type == "basic"
                        || this.subObjects[obj.name].$.type == "group"){
                        try {
                            this.ctx.save();
                            this.ctx.scale(devicePixelRatio, devicePixelRatio);
                            this.subObjects[obj.name].$.onDraw(this.ctx);
                            this.ctx.restore();
                        }catch(error){
                            console.log("**********" + obj.name + "无onDraw函数**********");
                            console.log(error);
                        }

                    }
                }
            }

        },
        /*
            参数：无
            作用：窗口关闭前被调用
        */
        onClose(){
            this.openOtimer = false;

            return new Promise((resolve)=>{
                try{
                    this.fvScript.executionScript(this.exitscript);
                }catch(e){
                    console.log(e);
                }
                var funcs = [];
                for (var p in this.subObjects) {
                    if(p == "$"){
                        continue;
                    }
                    if(this.subObjects[p].$.onClose){
                        funcs.push(this.subObjects[p].$.onClose());
                    }
                };
                Promise.all(funcs).then(()=>{
                        //this.distroyed();
                        //this.$el.removeChild(this.$el.childNodes[0]);
                    resolve(true)
                });
            })

        },
        /*
            参数：isShow 显隐标记
            作用：设置窗口显隐
        */
        show(isShow){
            this.isShow = isShow ? true : false;
            this.tcanvasNode.offsetParent.parentNode.parentNode.style.zIndex = 9999;
        },
        setPosition(left,top){
            if(this.turn == "portrait" ||this.turn == "portraits"){
                this.x +=-top;
                if(this.x > 0){
                    this.x = 0;
                }else if(this.x < -(parseFloat(this.$refs.dialog.$refs.content.style.width)-parseFloat(window.innerWidth))){
                    this.x = -(parseFloat(this.$refs.dialog.$refs.content.style.width)-parseFloat(window.innerWidth));
                }
                this.y +=left;
            }else{
                this.x +=left;
                this.y +=top;
            }
            this.repaint();
        },
        repaint(info){
             if(this.$refs == undefined || this.$refs.dialog == undefined){return;}
            if(info == "transverse" || info == "vertical"){
                this.x = this.windowStyle.left;
                this.y = this.windowStyle.top;
                this.$store.state.system.$.screenWidth = this.windowStyle.width;
                this.$store.state.system.$.screenHeight = this.windowStyle.height;
            }else if(info=="reduction"){
                    this.x = this.windowStyle.left;
                    this.y = this.windowStyle.top;
                    this.$store.state.system.$.screenWidth = this.$store.state.system.$.scaleWidth;
                    this.$store.state.system.$.screenHeight = this.$store.state.system.$.scaleHeight;
            }else if(info){
                this.x += info.x;
                this.y += info.y;
                
            }
            //用于缩放 先百分百显示
            this.tcanvasNode.style.zoom = 1;
            this.ctx.clearRect(0,0,(parseFloat(this.width) * this.scaleX) * devicePixelRatio,this.canvasHeight*this.scaleY+300);
            //计算缩放信息
            this.zoomMagnification();
            //根据缩放来重新计算缓存大小
            this.ctx.canvas.width = (parseFloat(this.width) * this.scaleX) * devicePixelRatio;
            this.ctx.canvas.height = (parseFloat(this.height) * this.scaleY) * devicePixelRatio
            if(info){
                if(isApp()){
                    //全局缓存 canvas
                    this.ctx.canvas.width += 100;
                    this.ctx.canvas.height += 100;
                }else{
                     //全局缓存 canvas
                    this.ctx.canvas.width += 15;
                    this.ctx.canvas.height += 15;
                }
            }
            //在打开窗口获取鼠标位置且判断鼠标在点击区域获取到值
            if(this.centerOpen && window.onmousemoveY != undefined){
                var y = parseFloat(window.onmousemoveY);
                var x = parseFloat(window.onmousemoveX);
                var w = (parseFloat(this.width) * this.scaleX)
                var h = (parseFloat(this.height) * this.scaleY)
                //缩放后大小
                var pos = {
                    "width": parseFloat(this.width) * this.scaleX + "px",
                    //20是边框宽度
                    "height": (parseFloat(this.height) * this.scaleY)+(this.heightTitle*this.scaleY) + "px",
                    "left": x+w/2-w + "px",
                    "top": y+h/2-h + "px"
                }
            }else{
                if(this.title){
                    var titleHeight = 46*this.scaleY;
                }else{
                    var titleHeight =0;
                }
                //缩放后大小
                var pos = {
                    "width": parseFloat(this.width) * this.scaleX+1 + "px",
                    //20是边框宽度
                    "height": (parseFloat(this.height) * this.scaleY)+(titleHeight) + "px",
                    "left": parseFloat(this.x) * this.scaleX + "px",
                    "top": parseFloat(this.y) * this.scaleY + "px"
                }
            }
            //是否全屏
            if(this.fullscreen){
                //全屏重置缩放大小中的位置。（全屏时左上角坐标）
                pos = this.fullScreenShow();
            }
            //判断边框给与赋值后在高度减去

            var showApp = this.setWindowStyle(pos);
            this.domScale = {
                zoom: this.zoom,
                x: parseFloat(pos.left),//窗口位置x
                y: parseFloat(pos.top),//窗口位置y
                sx: this.scaleX,//缩放比例x
                sy: this.scaleY,//缩放比例y
                ox: 0,//位置偏移x(滚轮缩放修改,已无用)
                oy: 0,//位置偏移y(滚轮缩放修改,已无用)
                titleHeight : this.heightTitle,//
                scrollHeight:this.$refs.canvasNode.scrollTop,
                scrollWidth:this.$refs.canvasNode.scrollLeft,
                isApp : showApp,
                winType:"pc",
                turn:this.turn,
                embedView:this.$store.state.system.$.embedView
            }
            this.$refs.dialog.$refs.content.parentElement.style.top=0+"px";
            this.$refs.dialog.$refs.content.parentElement.style.left=0+"px";
            // this.doFixEventTop = parseFloat(this.tcanvasNode.offsetParent.style.top);
            // this.doFixEventleft = parseFloat(this.tcanvasNode.offsetParent.style.left);
            this.reDraw();
            //用于缩放 否则苹果手机图元无法放大缩小 用屏幕比缩放，来实现清晰度
            this.tcanvasNode.style.zoom = 1/devicePixelRatio;
        },
        /*
            参数：无
            作用：重绘
        */
        reDraw(){
            for (var p in this.subObjects) {
                try {
                    if(p == "$"){
                        continue;
                    }
                    if(this.subObjects[p].$.reDraw){
                        //属性display不存在或者不为block时，图元隐藏，不去绘制
                      if(!this.subObjects[p].$.display || this.subObjects[p].$.display == "block"){
                        // 图元存在垂直水平移动动画后绘制  注：因如果添加此判断，调用放大所有，加有垂直动画的图元不能缩放
                        // if(this.subObjects[p].$.animation && this.subObjects[p].$.fctype.indexOf('Obj') >= 0 && (this.subObjects[p].$.animation.fvVerticalMove || this.subObjects[p].$.animation.fvHorMove)){
                        //   continue;
                        // }
                        this.subObjects[p].$.reDraw(this.domScale);
                      }
                    }

                }catch(error){
                    console.log("**********" + p + " reDraw函数**********");
                    console.log(error);
                }
            }
        },
        /*
            参数：无
            作用：全屏显示需要的设置
        */
        fullScreenShow(){
            var pos = {
                "width": window.innerWidth + "px",
                "height": window.innerHeight - this.heightTitle + "px",
                "left": "0px",
                "top": "0px"
            }
            this.scaleX = parseFloat(window.innerWidth) / (parseFloat(this.width))+0.01 ;
            this.scaleY = (parseFloat(window.innerHeight) - this.heightTitle) / (parseFloat(this.height)-20);
            this.$refs.dialog.$refs.content.style.top="0px";
            this.$refs.dialog.$refs.content.style.left="0px";
            this.$refs.dialog.$refs.content.style.width = window.innerWidth +"px";
            this.$refs.dialog.$refs.content.style.height = window.innerHeight +"px";
            return pos;
        },
        /*
            参数：e 鼠标信息
            作用：鼠标按下时被调用
        */
        onMouseDown(e){
            this.setFourceWindow();
            this.doFixEvent(e,"onMouseDown",this.doFixEventOnMouseUp);
        },

        /*
            参数：e 鼠标信息
            作用：鼠标弹起时被调用
        */
        onMouseUp(e){
            this.setFourceWindow();
            this.doFixEvent(e,"onMouseUp",this.doFixEventOnMouseUp);

        },
        //拖动窗口事件
        onMouseUps(e){
            this.y = parseFloat(this.$refs.dialog.$refs.content.style.top)/this.scaleY;
            this.x = parseFloat(this.$refs.dialog.$refs.content.style.left)/this.scaleX;
            this.repaint();
        },
        /*
            参数：e 鼠标信息
            作用：鼠标移动时被调用
        */
        onMouseMove(e){
            this.setFourceWindow();
            this.doFixEvent(e,"onMouseMove",this.doFixEventOnMouseUp);
        },
        /*
            参数：e 鼠标信息
            作用：鼠标离开时被调用
        */
        onMouseLeave(e){
            this.setFourceWindow();
            this.doFixEvent(e,"onMouseLeave",this.doFixEventOnMouseUp);

        },
        /*
            参数：e 鼠标信息
            作用：鼠标进入时被调用
        */
        onMouseEnter(e){
            this.setFourceWindow();
            this.doFixEvent(e,"onMouseEnter",this.doFixEventOnMouseUp);
        },
        /*
            功能:鼠标坐标系转换
            参数:evt 鼠标信息
            返回值:无
        */
        mouseX(evt) {
            if (evt.pageX) return evt.pageX;
            else if (evt.clientX)
                return evt.clientX + (document.documentElement.scrollLeft ?
                        document.documentElement.scrollLeft :
                        document.body.scrollLeft);
            else return null;
        },
        /*
            功能:鼠标坐标系转换
            参数:evt 鼠标信息
            返回值:无
        */
        mouseY(evt) {
            if (evt.pageY) return evt.pageY;
            else if (evt.clientY)
            return evt.clientY + (document.documentElement.scrollTop ?
                    document.documentElement.scrollTop :
                    document.body.scrollTop);
        },
        /*
            参数：e 鼠标信息，type 鼠标错做类型，doFixEventOnMouseUp 用于传入移动窗口的距离
            作用：下发鼠标消息到各基本图元，处理修改鼠标样式
        */
        doFixEvent(e,type,doFixEventOnMouseUp){
            var eventX = e.clientX + this.tcanvasNode.parentElement.scrollLeft;
            var eventY = e.clientY + this.tcanvasNode.parentElement.scrollTop;
            var style = "default";
            for(var p in this.subObjects){
                if(p == "$") continue;
                if(this.subObjects[p].$.type == "basic"){


                    this.subObjects[p].$[type](e,this.domScale,doFixEventOnMouseUp);
                    //判断是否有动画， 如果有动画进入
                    if(this.subObjects[p].$.isAnimation){
                        if(type == "onMouseMove"
                            && this.subObjects[p].$.isHasAnimation(["fvLmousescript","fvRmousescript","fvMousescript"])
                            && this.subObjects[p].$.mouseState){
                            style = "pointer";
                            break;
                        }
                    }
                }else if(this.subObjects[p].$.doFixEvent){

                    if(this.subObjects[p].$.isAnimation){
                        this.subObjects[p].$[type](e,this.domScale,doFixEventOnMouseUp);
                        var p1 = this.subObjects[p].$.isHasAnimation(["fvLmousescript","fvRmousescript","fvMousescript"]);
                        var p2 = this.subObjects[p].$.mouseState;
                        if(type == "onMouseMove"
                            && p1
                            && p2){
                            style = "pointer";
                            break;
                        }else{
                            var subStyle = this.subObjects[p].$.doFixEvent(e,type,doFixEventOnMouseUp);
                        }
                    }else{
                        this.subObjects[p].$[type](e,this.domScale,doFixEventOnMouseUp);
                        var subStyle = this.subObjects[p].$.doFixEvent(e,type,doFixEventOnMouseUp);
                        //为打组添加点击事件 状态
                        if(this.subObjects[p].$.type == "group"){
                            var leftX = this.subObjects[p].$.x + +this.domScale.x;
                            var rightX = leftX + this.subObjects[p].$.regionWidth;
                            var topY =  this.subObjects[p].$.y +this.domScale.titleHeight+this.domScale.y;
                            var bottomY = this.subObjects[p].$.regionHeight + topY;
                            if(     eventX < rightX
                                && eventX > leftX
                                && eventY < bottomY
                                && eventY > topY) {
                                subStyle = "pointer";
                            }else{
                                subStyle = "default";

                            }
                        }
                    }
                    if(style == "default"){
                        style = subStyle;
                    }
                }
            }
            if(type == "onMouseMove"){
                this.ctx.canvas.style.cursor = style;
            }
        },
        /*
            参数：obj 选中的对象
            作用：设置当前窗口选中的对象
        */
        select(obj){
            this.selected = obj;
        },
        /*
            参数：无
            作用：设置窗口边框风格
        */
        setWindowStyle(pos){
            if(this.$refs == undefined || this.$refs.dialog == undefined){return;}
            //判断是否是弹出窗口， 如果是弹出式赋值为最顶级
            if(this.windowShowStyle){
                //且 打开窗口关闭才给设置最高层级
                if(this.autoclose){
                    //this.tcanvasNode.offsetParent.parentNode.parentNode.style.zIndex = 88888;
                }
            }
            var width = this.canvasWidth > parseInt(pos.width) ? this.canvasWidth * this.scaleX + "px" : pos.width;
            var height = this.canvasHeight > parseInt(pos.height) ? this.canvasHeight * this.scaleY + "px" : pos.height;
            this.$refs.dialog.$refs.content.style.backgroundColor = this.borderColor;
            var result = isApp();
            if(this.$store.state.system.$.embedView != 1){
                if(result){
                    if(this.turn =="transverse" || this.turn =="portrait" || this.turn =="portraits"){
                        this.setPcWindowStyle(pos);
                    }else{
                        this.setAppWindowStyle(pos);
                    }
                }else{

                    this.setPcWindowStyle(pos);
                }
            }else{
                this.setPcWindowStyle(pos);
            }

            //设置canvas 宽高
            var solidWidth = 0;
            if(this.borderWidth == 2){
                this.$refs.dialog.$refs.content.style.border = "5px solid #85ABE4";
                solidWidth = 10;
            }else if(this.borderWidth == 1){
                this.$refs.dialog.$refs.content.style.border = "2px solid #85ABE4";
                solidWidth = 4;
            }else{
                this.$refs.dialog.$refs.content.style.border = "0px solid #85ABE4";
            }

            this.tcanvasNode.parentElement.style.width = pos.width;
            this.tcanvasNode.parentElement.style.height = pos.height;

            var svgLeftX =  window.innerWidth - parseFloat(pos.left) - this.heightTitle;
            var svgTopY =  window.innerHeight - parseFloat(pos.top) - this.heightTitle;
            if(parseFloat(pos.height)>svgTopY){
                this.tcanvasNode.parentElement.style.height = svgTopY+"px";
            }
            if(parseFloat(pos.width)>svgLeftX){
                this.tcanvasNode.parentElement.style.width = svgLeftX+"px";
            }
            //canvas高度加1像素是为了计算有一定的误差导致canvas拼接会有缝隙
            if(this.isTitle){
                //有滚动条。设置canvas的高度和宽度
                if(this.scroll){
                    if(!this.iskko && !this.isokk){
                        if(isApp()){
                            this.tcanvasNode.parentElement.style.overflow = "visible";
                        }else{
                            //根据图元的位置判断是否添加滚动条
                            if(parseFloat(this.tcanvasNode.parentElement.style.height)< parseFloat(this.canvasHeight)){
                                this.tcanvasNode.parentElement.style.overflow = "auto";
                            }else{
                                this.tcanvasNode.parentElement.style.overflow = "hidden";
                            }
                        }
                    }else{
                        this.tcanvasNode.parentElement.style.overflow = "auto";
                    }
                    this.tcanvasNode.height = this.canvasHeight-this.heightTitle+20;
                    this.tcanvasNode.width = this.canvasWidth+20;
                }else{
                    if(isApp()){
                        this.tcanvasNode.parentElement.style.overflow = "visible";
                    }else{
                        this.tcanvasNode.parentElement.style.overflow = "hidden";
                    }
                    this.tcanvasNode.height = (parseFloat(pos.height) - this.heightTitle - solidWidth)*devicePixelRatio+1;
                    this.tcanvasNode.width = (parseFloat(pos.width) - solidWidth)*devicePixelRatio;
                }
            }else{
                //没有滚动条。设置canvas的高度和宽度为窗口的宽高
                if(this.scroll){
                    if(!this.iskko && !this.isokk){
                        if(isApp()){
                            this.tcanvasNode.parentElement.style.overflow = "visible";
                        }else{
                            //根据图元的位置判断是否添加滚动条
                            if(parseFloat(this.tcanvasNode.parentElement.style.height)< parseFloat(this.canvasHeight)){
                                this.tcanvasNode.parentElement.style.overflow = "auto";
                            }else{
                                this.tcanvasNode.parentElement.style.overflow = "hidden";
                            }
                        }
                    }else{
                        this.tcanvasNode.parentElement.style.overflow = "auto";
                    }
                    if(isApp()){
                        this.tcanvasNode.height = (parseFloat(pos.height) - this.heightTitle - solidWidth)*devicePixelRatio+21;
                        this.tcanvasNode.width = (parseFloat(pos.width) - solidWidth)*devicePixelRatio+20;
                    }else{
                        this.tcanvasNode.height = this.canvasHeight+20;
                        this.tcanvasNode.width = this.canvasWidth+20;
                    }
                    
                    //窗口高度超过1500 缩放精度计算有偏差， 不添加滚动条高度
                    if(this.canvasHeight > 1500){
                        this.tcanvasNode.height = this.canvasHeight-20;
                        this.tcanvasNode.width = this.canvasWidth-20;
                    }

                }else{
                    if(isApp()){
                            this.tcanvasNode.parentElement.style.overflow = "visible";
                        }else{
                            this.tcanvasNode.parentElement.style.overflow = "hidden";
                        }
                    this.tcanvasNode.height = (parseFloat(pos.height) - this.heightTitle - solidWidth)*devicePixelRatio;
                    this.tcanvasNode.width = (parseFloat(pos.width) - solidWidth)*devicePixelRatio;
                }
            }

            //清空，否则拖动事件位置不对
            this.$refs.dialog.$refs.content.parentNode.style.width = "";
            //重置 父级的宽高，因打开窗口有一个最小高度，导致打开窗口闪白

            if(result && this.$refs.dialog.$refs.content.style.transform == "rotate(90deg)" ){
                this.$refs.dialog.$refs.content.style.overflow = "auto";
            }
            return result;
        },
        setPcWindowStyle(pos){
            var appTop = 0;
            if(this.turn =="portraits"){
                var appTop = 30;
            }
            if(this.turn =="transverse"){
                this.$refs.dialog.$refs.content.style.width = pos.width;
                this.$refs.dialog.$refs.content.style.height = pos.height;
                this.$refs.dialog.$refs.content.style.top= -parseFloat(pos.height) + parseFloat(pos.left) + "px";
                this.$refs.dialog.$refs.content.style.left= window.innerWidth - parseFloat(pos.height)-parseFloat(pos.top)+"px";
                this.$refs.dialog.$refs.content.style.transform="rotate(90deg)";
                this.$refs.dialog.$refs.content.style.transformOrigin="0% 100% 0";
            }else{
                this.$refs.dialog.$refs.content.style.top = parseFloat(pos.top)+appTop+"px";
                this.$refs.dialog.$refs.content.style.left = pos.left;
                this.$refs.dialog.$refs.content.style.width = pos.width;
                this.$refs.dialog.$refs.content.style.height =parseFloat(pos.height)+"px";
            };
        },

        setAppWindowStyle(pos){
            this.$refs.dialog.$refs.content.style.width = pos.width;
            this.$refs.dialog.$refs.content.style.height = pos.height;
            this.$refs.dialog.$refs.content.style.top= -parseFloat(pos.height) + this.$store.state.system.$.appWinTitleHeight + parseFloat(pos.left) + "px";
            this.$refs.dialog.$refs.content.style.left= window.innerWidth - parseFloat(pos.height)-parseFloat(pos.top)+"px";
            this.$refs.dialog.$refs.content.style.transform="rotate(90deg)";
            this.$refs.dialog.$refs.content.style.transformOrigin="0% 100% 0";
        },

        cleanUpFource(){
            this.isFocusWindow = false;
        },

        setFourceWindow(){
            this.isFocusWindow = true;
            this.$store.state.system.manager.$.setFocusWindow(this.registerName);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/system/windowComponent.vue